import {ValidationErrorKeys} from '@hconnect/common/consts'
import {TFunction} from 'i18next'
import {object as yupObject, number as yupNumber, AnySchema} from 'yup'

import {KpiValuesById} from '../types'

export const getSlaKpiValuesValidationSchema = (kpiValuesById: KpiValuesById, t: TFunction) => {
  const schemaShape: Record<string, AnySchema> = {}

  // Create validation schema for each KPI field
  Object.keys(kpiValuesById).forEach((kpiId) => {
    schemaShape[kpiId] = yupNumber()
      .nullable() // Allow null values (empty fields)
      .typeError(t(ValidationErrorKeys.REQUIRED))
  })

  return yupObject().shape(schemaShape)
}
